"use client";
import { createContext, useContext } from "react";
const Alignments = {
  LEFT: "left",
  CENTER: "center",
  RIGHT: "right"
};
const Shapes = Object.freeze({
  SQUARE: "square",
  ROUNDED: "rounded",
  PILL: "pill"
});
const Sizes = Object.freeze({
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large"
});
const Contrasts = Object.freeze({
  LIGHT: "light",
  DARK: "dark"
});
const Context = createContext({});
function useFormContext() {
  return useContext(Context);
}
const { Provider } = Context;
export {
  Alignments,
  Contrasts,
  Provider,
  Shapes,
  Sizes,
  useFormContext
};
//# sourceMappingURL=FormContext.js.map